import { render, staticRenderFns } from "./Scrk.vue?vue&type=template&id=30734cd2&scoped=true&"
import script from "./Scrk.vue?vue&type=script&lang=js&"
export * from "./Scrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30734cd2",
  null
  
)

export default component.exports